import { useQuery } from '@tanstack/react-query';
import { api } from '~/api/utils/api-base';
import { TagCategory } from '~/shared/types/tag-category';

export const useFetchTagCategories = () => {
  return useQuery({
    queryKey: ['tag_categories'],
    queryFn: async () => {
      const response = await api.get<TagCategory[]>('/tag_categories');
      return response.data;
    },
  });
};
